import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Button, message } from 'antd'
import CardManagement from '../../components/cards/CardManagement'
import SubscriptionStatus from '../../components/billing/SubscriptionStatus'
import authActions from '../../redux/auth/actions'
import { loginUserType } from '../../helpers/constants'
import { siteConfig } from '../../settings'
import { StyledPayment } from './payment.style'

// Legacy Stripe v2 screen (kept for reference):
// import { Elements, StripeProvider } from 'react-stripe-elements'
// import StripeForm from './StripeForm'
// <StripeProvider apiKey="pk_test_..." advancedFraudSignals={false}><Elements>...</Elements></StripeProvider>

/*
 * Payment screen (/paymentinfo). The app redirects here when the API answers "payment required"
 * (HTTP 401, status 2), e.g. when the company's BBPIE subscription has ended.
 * Admins can manage cards and reactivate the subscription; employees are asked to contact their admin.
 */
const { pendingPayment } = authActions
const PaymentScreen = props => {
  const [cardsVersion, setCardsVersion] = useState(0)
  const [accessRestored, setAccessRestored] = useState(false)
  const isAdmin = props.userType === loginUserType.admin || props.userType === loginUserType.superadmin

  useEffect(() => {
    if (!props.id) {
      message.error('Please try sign in again !!!')
      props.pendingPayment({ showPage: false, userId: 0, hasCard: false })
    }
  }, [])

  // Any subscription that is not ended (trial, active, past due) gives access again.
  const handleStatusChange = subscription => {
    setAccessRestored(!!subscription && !!subscription.status && subscription.status !== 'inactive')
  }

  const goToApp = () => props.history.push('/dashboard')

  return (
    <StyledPayment>
      <div className='content-container pa-50px'>
        <h3 className='mtb-10px'>
          {isAdmin
            ? `Your ${siteConfig.siteName} subscription needs attention.`
            : `Your company's ${siteConfig.siteName} subscription is not active.`}
        </h3>

        <SubscriptionStatus
          companyId={props.companyId}
          canManage={isAdmin}
          refreshKey={cardsVersion}
          onStatusChange={handleStatusChange}
        />

        {isAdmin && (
          <CardManagement
            userId={props.id}
            companyId={props.companyId}
            auth={props.auth}
            onCardChange={() => setCardsVersion(v => v + 1)}
            autoOpenAddModal={!props.hasCard}
          />
        )}

        {!isAdmin && (
          <p className='mtb-10px'>Please contact your company administrator to renew the subscription.</p>
        )}

        {accessRestored && (
          <div style={{ marginTop: 24, textAlign: 'center' }}>
            <Button type='primary' size='large' onClick={goToApp}>Continue to {siteConfig.siteName}</Button>
          </div>
        )}
      </div>
    </StyledPayment>
  )
}

const mapStateToProps = state => ({
  id: state.Auth.id,
  hasCard: state.Auth.hasCard,
  companyId: state.Auth.company && state.Auth.company.id,
  userType: state.Auth.type,
  auth: state.Auth
})

export default connect(mapStateToProps, { pendingPayment })(PaymentScreen)
